import React from "react";
import { useTranslation } from "react-i18next";
import { BellRing, Megaphone, MessageCircle, PackageX } from "lucide-react";
import { PageHeader } from "components/ui/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "components/ui/Tabs";
import useUrlState from "hooks/useUrlState";
import useAuth from "hooks/useAuth";
import { roleRoutes } from "utils/roles";
import WhatsappAlertsPanel from "./WhatsappAlertsPanel";
import DriverNotificationsPanel from "./DriverNotificationsPanel";
import BulkFailedDeliveryPanel from "./BulkFailedDeliveryPanel";
import ClientPopupsPanel from "./ClientPopupsPanel";

// Mismos roles que acepta el backend para crear pop-ups (contracts): admin y
// superadmin logístico. Supervisor y soporte no ven la pestaña.
const POPUP_AUTHOR_ROLES = new Set([roleRoutes.admin, roleRoutes.superadmin]);

export default function AdminNotifications() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const canManagePopups = POPUP_AUTHOR_ROLES.has(user?.role);
  const [tab, setTab] = useUrlState("tab", "drivers", { push: true });

  return (
    <div className="w-full min-w-0 p-4 md:p-8 flex flex-col gap-6">
      <PageHeader
        icon={<BellRing className="w-6 h-6 text-fg-muted" />}
        title={t("Notificaciones")}
        subtitle={t(
          "Envía alertas operacionales a repartidores y clientes de forma segmentada."
        )}
      />

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList ariaLabel={t("Notificaciones")}>
          <TabsTrigger value="drivers" icon={<BellRing />}>
            {t("Repartidores")}
          </TabsTrigger>
          <TabsTrigger value="clients" icon={<MessageCircle />}>
            {t("Clientes (WhatsApp)")}
          </TabsTrigger>
          {canManagePopups && (
            <TabsTrigger value="popups" icon={<Megaphone />}>
              {t("Pop-ups a comercios")}
            </TabsTrigger>
          )}
          <TabsTrigger value="bulk-status" icon={<PackageX />}>
            {t("Entrega fallida masiva")}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="drivers" className="pt-6">
          <DriverNotificationsPanel />
        </TabsContent>
        <TabsContent value="clients" className="pt-6">
          <WhatsappAlertsPanel />
        </TabsContent>
        {canManagePopups && (
          <TabsContent value="popups" className="pt-6">
            <ClientPopupsPanel />
          </TabsContent>
        )}
        <TabsContent value="bulk-status" className="pt-6">
          <BulkFailedDeliveryPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}
